import { Injectable } from '@angular/core';
import { BackendEndpointService } from './backend-endpoint.service';

@Injectable()
export class BackendWrapperService {
  public uiType = '';

  constructor(private backendEndpointService: BackendEndpointService) {}

  private buildHeaders(additionalOptions = null) {
    // copy the original options
    let ret = additionalOptions;
    if (!ret) {
      ret = {};
    }

    if (typeof ret.headers === 'undefined') {
      ret.headers = null;
    }

    const baseHeader = {
      'pathfinder-ui': this.uiType
    };

    ret.headers = { ...ret.headers, ...baseHeader };

    return ret;
  }

  private returnData(request: Promise<any>): Promise<any> {
    return new Promise((res, rej) => {
      request
        .then(result => {
          if (typeof result === 'string') {
            const json = this.isJson(result);
            if (json === -1) {
              res({ data: result });
            } else {
              res(json);
            }
          } else {
            res(result);
          }
        })
        .catch(err => rej(err));
    });
  }

  private isJson(str): any {
    try {
      const json = JSON.parse(str);
      return json;
    } catch (e) {
      return -1;
    }
  }

  public async get(path, additionalHeaders = null): Promise<any> {
    const httpOptions = this.buildHeaders(additionalHeaders);
    return this.returnData(this.backendEndpointService.get(path, httpOptions));
  }

  public async post(path, body, additionalHeaders = null): Promise<any> {
    if (typeof body !== 'undefined' && !(body instanceof FormData)) {
      body = JSON.parse(JSON.stringify(body));
    }
    const httpOptions = this.buildHeaders(additionalHeaders);
    return this.returnData(this.backendEndpointService.post(path, body, httpOptions));
  }

  public async postFile(path, formData, additionalHeaders = null): Promise<any> {
    const httpOptions = this.buildHeaders(additionalHeaders);
    return this.returnData(this.backendEndpointService.postFile(path, formData, httpOptions));
  }

  public async put(path, body, additionalHeaders = null): Promise<any> {
    if (typeof body !== 'undefined') {
      body = JSON.parse(JSON.stringify(body));
    }
    const httpOptions = this.buildHeaders(additionalHeaders);
    return this.returnData(this.backendEndpointService.put(path, body, httpOptions));
  }

  public async delete(path, additionalHeaders = null): Promise<any> {
    const httpOptions = this.buildHeaders(additionalHeaders);
    return this.returnData(this.backendEndpointService.delete(path, httpOptions));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/backend-wrapper.service.ts